<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 8.5H13.5" [attr.stroke]="stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 3V14" [attr.stroke]="stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>